import $ from 'jquery';

$(document).ready(function () {

    var bgImage = $('header').css('background-image');
    var bgColor = $('header').css('background-color');

    if (($('main').hasClass('campaign-page') && $('.gift-listing').length) || $('main').hasClass('gift-page')) {
        if (bgImage.length > 0) {
            $('body').addClass('campaign-bg-image');
        }

        if ($('body').hasClass('campaign-bg-image')) {
            $('body').css('background-image', bgImage);
            $('body').css('background-color', bgColor);
        }
    }

    if (($('main').hasClass('campaign-page') && $('.gift-listing').length)) {
        $('body').addClass('gift-campaign');
    }

    buildWaMessage();

    $('#greeting').change(function () {

        var greeting = $(this).val();

        if (greeting == "own") {
            $('#own_greeting').removeAttr("disabled");
        } else {
            $('#own_greeting').attr("disabled", "disabled");
        }
        buildWaMessage();
    });

    $('#own_greeting').keyup(function () {
        buildWaMessage();
    });

    $('#greeting_text').keyup(function () {
        buildWaMessage();
    });

    $('#send_gift_wa').on("click", (function () {
        try {
            var giftId = $('#send_gift_wa').attr('gift-id');
            if (isInt(giftId)) {
                sendGift(giftId);
            }
            else {
                return true;
            }
        }
        catch {
            return true;
        }
    }));

    if (window.location.search.indexOf('?mode=sent') > -1) {
        $('#gift_confirmation').css("display", "block");
        $('#gift_success').css("display", "block");
        $('#gift_form').addClass('hide');
    } else if (window.location.search.indexOf('?mode=error_sent') > -1) {
        $('#gift_confirmation').css("display", "block");
        $('#gift_fail').css("display", "block");
        $('#gift_form').addClass('hide');
    } else if (window.location.search.indexOf('?mode=captcha_fail') > -1) {
        $('#gift_confirmation').css("display", "block");
        $('#captcha_fail').css("display", "block");
        $('#gift_form').addClass('hide');
    } else if (window.location.search.indexOf('?mode=gift') > -1) {
        $('#gift_form_container').addClass('hide');
        $('#gift_back_button').addClass('hide');
    }  else {
        $('#gift_confirmation').addClass('hide');
    }

    function buildWaMessage() {
        var greeting;
        var greetingValue = $('#greeting').val();
        if (greetingValue == null) {
            return;
        }
        if (greetingValue == "own") {
            greeting = $('#own_greeting').val();
        }
        else {
            greeting = $('#greeting option:selected').text();
        }

        var greeting_text = $('#greeting_text').val();
        if (greeting_text.trim()) {
            if (greeting) {
                greeting += '\n';
            }
            greeting += greeting_text;
        }

        greeting += '\n' + window.location.origin + window.location.pathname + '?mode=gift';

        $('#wa_link').attr('href', 'https://wa.me/?text=' + encodeURIComponent(greeting));
    }

    function sendGift(giftId) {
        $.get('/api/v1/gifts/addsent', { 'giftid': giftId })
        return true;
    }

    function isInt(value) {
        return !isNaN(value) &&
            parseInt(Number(value)) == value &&
            !isNaN(parseInt(value, 10));
    }
});